var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrows 1",
    clipPath: "url(#clip0_3866_99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.473 4.236L10.7315 4.23599C10.6544 4.23715 10.5809 4.26858 10.5268 4.3235C10.4727 4.37841 10.4423 4.4524 10.4423 4.52949C10.4423 4.60658 10.4727 4.68057 10.5267 4.7355C10.5808 4.79042 10.6544 4.82186 10.7314 4.82303L11.831 4.82303L4.72369 11.9303L4.72369 10.8308C4.72252 10.7537 4.69108 10.6802 4.63616 10.6261C4.58124 10.572 4.50724 10.5417 4.43015 10.5417C4.35307 10.5417 4.27908 10.572 4.22416 10.6261C4.16924 10.6802 4.13781 10.7537 4.13665 10.8308L4.13667 12.5723C4.13678 12.6678 4.17477 12.7594 4.24231 12.8269C4.30984 12.8945 4.4014 12.9325 4.49691 12.9326L6.2384 12.9326C6.31558 12.9316 6.38926 12.9002 6.44348 12.8453C6.49771 12.7904 6.52812 12.7163 6.52812 12.6391C6.52813 12.5619 6.49774 12.4878 6.44352 12.4329C6.3893 12.3779 6.31563 12.3465 6.23845 12.3455L5.13887 12.3455L8.69252 8.79185L12.2462 5.23821L12.2462 6.33778C12.2468 6.41525 12.278 6.48933 12.333 6.5439C12.3879 6.59847 12.4623 6.62908 12.5397 6.62909C12.6172 6.62909 12.6915 6.59847 12.7465 6.54391C12.8015 6.48935 12.8327 6.41526 12.8333 6.3378L12.8333 4.59628C12.8332 4.50075 12.7952 4.40917 12.7276 4.34163C12.6601 4.27409 12.5685 4.2361 12.473 4.236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17797",
    x: 7.79297,
    y: 8.5,
    width: 1,
    height: 1,
    transform: "rotate(-45 7.79297 8.5)",
    fill: "#EFEFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3866_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 8.58429) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/expand-arrow.b688a5509737e2ec034547259d42be91.svg";
export { ForwardRef as ReactComponent };